import { useMemo } from "react";
import { getPlanType } from "utils/planPackageUtils";
import { useAppSelector } from "hooks/useAppSelector";

const usePlanType = () => {
  const selectedPlanPackage = useAppSelector(
    (state) => state.buyFlow.selectedPlanPackage
  );
  const planType = useMemo(() => {
    if (!selectedPlanPackage) return undefined;
    return getPlanType(selectedPlanPackage);
  }, [selectedPlanPackage]);

  return planType;
};

export default usePlanType;
